import "./style.less";
import { FC } from "react";

const VuiContent: FC = ({ children }) => {
  return <div className="vui-content-wrapper">{children}</div>;
};

export default VuiContent;
